import type { SupportedLanguage } from "@krea/shared/types/common";

export const privacyPolicyLink = (
  country: string,
  websiteUrl: string,
  lang: SupportedLanguage,
): string => {
  const linksSE = (lang: SupportedLanguage): string => {
    switch (lang) {
      case "sv":
        return "information/integritetspolicy/";
      case "en":
      case "fi":
        return "en/privacy-policy/";
      default: {
        const exhaustiveCheck: never = lang;
        console.error(exhaustiveCheck);
        return "";
      }
    }
  };

  const linksFI = (lang: SupportedLanguage): string => {
    switch (lang) {
      case "fi":
      case "sv":
      case "en":
        return "kaytannot/tietosuoja/";
      default: {
        const exhaustiveCheck: never = lang;
        console.error(exhaustiveCheck);
        return "";
      }
    }
  };

  switch (country) {
    case "SE":
      return `${websiteUrl}/${linksSE(lang)}`;
    case "FI":
      return `${websiteUrl}/${linksFI(lang)}`;
    default:
      return `${websiteUrl}/privacy-policy`;
  }
};
